/**
 * Industrias de cliente — catalogo delegado al asistente.
 *
 * Mismo caso que Tipos de Proyecto: ABM de tres campos, frecuencia trimestral,
 * y tres tools ya registradas que lo cubren — `list_client_industries`,
 * `create_client_industry` y `update_client_industry` (renombrar, reordenar,
 * activar/desactivar).
 *
 * El DELETE duro que tenia la pantalla no tiene tool y no se repuso: aca era
 * indistinguible de desactivar. `clients.industry` es texto libre sin FK, asi
 * que borrar la fila nunca toco a los clientes ya guardados — lo unico que
 * hacia era sacar la opcion del formulario, que es exactamente lo que hace
 * `is_active = false`. El propio dialogo de confirmacion lo decia asi.
 *
 * Se sigue exportando igual porque lo monta ClientList como pestana
 * "Industrias".
 *
 * @module pages/settings/ClientIndustriesSettings
 */

import React from 'react';
import CatalogoDelegadoPanel from './CatalogoDelegadoPanel';

const ClientIndustriesContent = () => (
  <CatalogoDelegadoPanel
    titulo="Las industrias las administra el asistente"
    intro="Pedíselo por chat y la opción queda disponible en el formulario de clientes al instante."
    ejemplos={[
      'Agregá la industria Veterinaria',
      'Desactivá la industria Distribuidor',
      'Mostrame todas las industrias, incluidas las inactivas',
    ]}
    nota="Las industrias activas son las que aparecen en el campo Industria al crear o editar un cliente. Los clientes que ya tienen una industria guardada la conservan aunque se desactive."
  />
);

export default ClientIndustriesContent;
